import AngleRightIcon from './AngleRightIcon'

export default AngleRightIcon
